import { defineComponent as _defineComponent } from 'vue'
interface Props {
  id?: number | string
  title: string
  subTitle?: string | null
  count?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VsNestedPickerListItem',
  props: {
    id: { default: null },
    title: null,
    subTitle: { default: null },
    count: { default: 0 }
  },
  emits: ['select', 'expand'],
  setup(__props: any, { emit }) {

const props = __props as { id: number | string, title: string, subTitle: string | null, count: number }





const clickAction = (e) => {
  e.stopPropagation()
  emit('select', props.id)
}

const click = () => {
  if (props.count > 0) {
    emit('expand', props.id)
  } else {
    emit('select', props.id)
  }
}

return { __sfc: true,props, emit, clickAction, click }
}

})